export default "__VITE_ASSET__c06e98e5__"